import {
  AccountProvider,
  AppProvider,
  AuthProvider,
  ClinicProvider,
  DentistProvider,
  KeyboardProvider,
  MobileNumberProvider,
  NetworkProvider,
  NotificationsProvider,
  OnboardingProvider,
  QueryProvider,
  RequestsProvider,
  SubscriptionProvider,
  TrackerProvider,
  VersionProvider
} from '@/contexts';

const AppProviders: React.FC<{ children: React.ReactNode }> = ({
  children
}) => {
  return (
    <QueryProvider>
      <AppProvider>
        <KeyboardProvider>
          <NetworkProvider>
            <VersionProvider>
              <TrackerProvider>
                <OnboardingProvider>
                  <AccountProvider>
                    <AuthProvider>
                      <ClinicProvider>
                        <DentistProvider>
                          <MobileNumberProvider>
                            <SubscriptionProvider>
                              <RequestsProvider>
                                <NotificationsProvider>
                                  {children}
                                </NotificationsProvider>
                              </RequestsProvider>
                            </SubscriptionProvider>
                          </MobileNumberProvider>
                        </DentistProvider>
                      </ClinicProvider>
                    </AuthProvider>
                  </AccountProvider>
                </OnboardingProvider>
              </TrackerProvider>
            </VersionProvider>
          </NetworkProvider>
        </KeyboardProvider>
      </AppProvider>
    </QueryProvider>
  );
};

export default AppProviders;
